import { useState } from "react";
import "./SettingSocial.css";

const SettingSocial = () => {
  const [facebookConnected, setFacebookConected] = useState(false);
  const [googleConnected, setGoogleConnected] = useState(false);
  const [discordConnected, setDiscordConnected] = useState(false);
  return (
    <div>
      <div className="settingSocial__section flex-row">
        <div className="settingSocial__details">
          <div className="flex-row">
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M9.96621 13.5227V21.6941H13.6187V13.5238H16.3406L16.8585 10.1437H13.6187V7.94801C13.5729 7.43695 13.7616 6.93271 14.1317 6.57734C14.5019 6.22198 15.0134 6.05395 15.5222 6.12058H17V3.24557C16.1339 3.10406 15.2585 3.02591 14.381 3.01173C13.1585 2.91938 11.9582 3.37567 11.1057 4.25683C10.2533 5.138 9.83696 6.35271 9.96972 7.57154V10.1437H7V13.5227H9.96621Z"
                fill="white"
              />
            </svg>

            <div>
              <h3>Facebook Account</h3>
              {facebookConnected ? (
                <a href="!#">www.facebook.com/geniusparkle</a>
              ) : (
                <small> Not Connected</small>
              )}
            </div>
          </div>
        </div>
        {facebookConnected ? (
          <button
            className="btn light settingSocial__btn disconnect"
            onClick={() =>
              setFacebookConected((facebookConnected) => !facebookConnected)
            }
          >
            Disconnect
          </button>
        ) : (
          <button
            className="btn primary settingSocial__btn"
            onClick={() =>
              setFacebookConected((facebookConnected) => !facebookConnected)
            }
          >
            Connect
          </button>
        )}
      </div>
      <div className="settingSocial__section flex-row">
        <div className="settingSocial__details">
          <div className="flex-row">
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M11.956 10.356V13.807H16.748C16.302 16 14.435 17.26 11.956 17.26C9.06851 17.2202 6.74862 14.8682 6.74862 11.9805C6.74862 9.09275 9.06851 6.74072 11.956 6.70098C13.1562 6.69954 14.3194 7.11605 15.246 7.87898L17.846 5.27898C14.8636 2.65705 10.508 2.31981 7.15752 4.45142C3.80707 6.58303 2.26698 10.6712 3.37821 14.4836C4.48943 18.296 7.98491 20.9164 11.956 20.914C16.423 20.914 20.485 17.665 20.485 11.98C20.4781 11.4326 20.411 10.8877 20.285 10.355L11.956 10.356Z"
                fill="white"
              />
            </svg>

            <div>
              <h3>Google Account</h3>
              {googleConnected ? (
                <a href="!#">www.google.com/geniusparkle</a>
              ) : (
                <small> Not Connected</small>
              )}
            </div>
          </div>
        </div>
        {googleConnected ? (
          <button
            className="btn light settingSocial__btn disconnect"
            onClick={() =>
              setGoogleConnected((googleConnected) => !googleConnected)
            }
          >
            Disconnect
          </button>
        ) : (
          <button
            className="btn primary settingSocial__btn"
            onClick={() =>
              setGoogleConnected((googleConnected) => !googleConnected)
            }
          >
            Connect
          </button>
        )}
      </div>
      <div className="settingSocial__section flex-row">
        <div className="settingSocial__details">
          <div className="flex-row">
            <svg
              width="24"
              height="24"
              viewBox="0 0 128 128"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M82.5421 94.4154C85.2439 97.8019 88.4824 101.614 88.4824 101.614C108.357 100.985 116 88.105 116 88.105C115.704 70.0696 111.272 52.3427 103.046 36.2897C95.7717 30.6929 86.9548 27.4632 77.7862 27.037L76.5279 28.4619C91.8134 33.0883 98.9195 39.7503 98.9195 39.7503C90.5355 35.1889 81.3485 32.2921 71.8645 31.2192C65.8271 30.5649 59.7334 30.627 53.7106 31.4043C53.1943 31.4216 52.6803 31.4835 52.1747 31.5894C45.1423 32.3723 38.2748 34.2453 31.8186 37.141C28.4136 38.6955 26.4706 39.7133 26.4706 39.7133C26.4706 39.7133 33.8728 32.6997 50.1206 28.0733L49.2138 27C40.0452 27.4262 31.2283 30.6558 23.9538 36.2527C15.7278 52.3057 11.2961 70.0326 11 88.068C11 88.068 18.5502 101.022 38.4251 101.577C38.4251 101.577 41.7561 97.5798 44.4579 94.1748C33.04 90.8068 28.7282 83.7007 28.7282 83.7007C28.7282 83.7007 29.635 84.3299 31.245 85.2182C31.3459 85.3247 31.465 85.4124 31.5966 85.4773C31.8742 85.6623 32.1332 85.7363 32.4108 85.9214C34.5294 87.0752 36.7244 88.083 38.9803 88.9378C43.2606 90.6043 47.6829 91.8802 52.1932 92.7499C59.8874 94.1788 67.7789 94.1788 75.473 92.7499C79.9212 91.9729 84.2669 90.694 88.4269 88.9378C92.0606 87.5856 95.5306 85.8289 98.7714 83.7007C98.7714 83.7007 94.3301 91.1399 82.5421 94.4154ZM49.2323 82.0352C44.2358 82.0352 40.1276 77.4644 40.1276 71.8757C39.9739 70.5902 40.0945 69.2866 40.4814 68.0511C40.8683 66.8155 41.5127 65.676 42.3721 64.7077C43.2316 63.7394 44.2865 62.9643 45.4674 62.4334C46.6483 61.9026 47.9283 61.6282 49.223 61.6282C50.5178 61.6282 51.7978 61.9026 52.9787 62.4334C54.1595 62.9643 55.2145 63.7394 56.0739 64.7077C56.9334 65.676 57.5778 66.8155 57.9647 68.0511C58.3516 69.2866 58.4722 70.5902 58.3185 71.8757C58.3909 73.1438 58.2121 74.4136 57.7922 75.6124C57.3724 76.8111 56.7199 77.915 55.8721 78.8608C55.0244 79.8066 53.9981 80.5755 52.8523 81.1235C51.7065 81.6714 50.4637 81.9876 49.1953 82.0538L49.2323 82.0352ZM81.7834 82.0352C76.7684 82.0538 72.7342 77.5569 72.7342 71.8943C72.9272 70.1357 73.6253 68.4706 74.7442 67.1002C75.8631 65.7298 77.3549 64.7128 79.0393 64.1719C80.7237 63.6311 82.5288 63.5895 84.2363 64.0524C85.9438 64.5152 87.4807 65.4626 88.6615 66.7801C89.8422 68.0976 90.6161 69.7288 90.8897 71.4767C91.1634 73.2245 90.925 75.0142 90.2035 76.6295C89.482 78.2448 88.3081 79.6166 86.8237 80.5792C85.3394 81.5418 83.6081 82.0539 81.8389 82.0538L81.7834 82.0352Z"
                fill="#062B31"
              />
            </svg>

            <div>
              <h3>Discord Account</h3>
              {discordConnected ? (
                <a href="!#">www.discord.com/geniusparkle</a>
              ) : (
                <small> Not Connected</small>
              )}
            </div>
          </div>
        </div>
        {discordConnected ? (
          <button
            className="btn light settingSocial__btn disconnect"
            onClick={() =>
              setDiscordConnected((discordConnected) => !discordConnected)
            }
          >
            Disconnect
          </button>
        ) : (
          <button
            className="btn primary settingSocial__btn"
            onClick={() =>
              setDiscordConnected((discordConnected) => !discordConnected)
            }
          >
            Connect
          </button>
        )}
      </div>
    </div>
  );
};

export default SettingSocial;
